module.exports = __webpack_public_path__ + "static/img/IKEGAI.40cd4a1b.png";